import { create } from 'zustand'

/** Hộp thoại "Giai đoạn khách hàng" mở được từ MỌI màn (bộ chọn giai đoạn, thanh giai đoạn…) — không điều hướng khỏi màn đang làm. */
interface StageManagerState {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useStageManagerStore = create<StageManagerState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}))

export const openStageManager = () => useStageManagerStore.getState().setOpen(true)
